import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerExpandableChangePasswordFormResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    form: {
      ExpandableChangePasswordForm: {
        cancel: 'Abbrechen',
        changePassword: 'Passwort ändern',
        changeToNewPassword: 'Neues Passwort verwenden',
        changeToNewPasswordError: 'Passwort ändern ist fehlgeschlagen.',
        changeToNewPasswordSuccess: 'Passwort ändern war erfolgreich.',
        currentPassword: 'Jetziges Passwort',
        currentPasswordIsRequired: '"Jetziges Password" muss ausgefüllt sein.',
        label: 'Passwort ändern',
        newPassword: 'Neues Passwort'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}